module.exports = {
      id: "nav-hamburger-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#nav-hamburger-usage",
      toString: function () {
        return this.url;
      }
    }